package com.milta.feature.delivery.data.repository

import androidx.compose.ui.text.intl.Locale
import com.milta.core.localization.resolveLanguageTag
import com.milta.feature.delivery.data.dto.CreateDeliveryRequest
import com.milta.feature.delivery.data.dto.toDomain
import com.milta.feature.delivery.data.remote.DeliveryApi
import com.milta.feature.delivery.domain.entity.AddressSuggestion
import com.milta.feature.delivery.domain.entity.Delivery
import com.milta.feature.delivery.domain.repository.DeliveryRepository

class DeliveryRepositoryImpl(private val api: DeliveryApi) : DeliveryRepository {

    override suspend fun createDelivery(
        routeId: String,
        recipientName: String?,
        address: String,
        phoneNumber: String?,
        deliveryTimeLimit: String?,
    ): Delivery = api.createDelivery(
        routeId = routeId,
        request = CreateDeliveryRequest(
            recipientName = recipientName,
            address = address,
            phoneNumber = phoneNumber,
            deliveryTimeLimit = deliveryTimeLimit,
        ),
    ).toDomain(routeId)

    // Locale.current is the same source MainActivity/Main.kt already resolve the app's own display
    // language from (device/browser locale, see resolveLanguageTag) — not tied to a Composable
    // context, safe to read from this plain data-layer class.
    override suspend fun autocompleteAddress(query: String): List<AddressSuggestion> =
        api.autocompleteAddress(query, resolveLanguageTag(Locale.current.language)).map { it.toDomain() }
}
